if (!customElements.get('quickbuy-variant-radios')) {
  customElements.define(
    'quickbuy-variant-radios',
    class QuickBuyVariantRadios extends VariantRadios {
      constructor() {
        super()

        this.dataset.updateUrl = false
        this.dataset.updateSwatch = false
        this.dataset.updateVariantTitle = true

        this.isBundle = this.closest('.js-bundle-product-card') !== null

        this.setupShowMoreButton()
      }

      onVariantChange() {
        this.updateOptions()
        this.updateMasterId()
        this.removeErrorMessage()
        this.updateVariantStatuses()

        if (!this.currentVariant) {
          this.setUnavailable()
        } else {
          this.updateATCButton()
          this.updateVariantInput()
          if (this.isBundle) this.updateProductMedia()
          this.updateProductCardMedia()
        }
      }

      setupShowMoreButton() {
        const showMoreButton = this.querySelector('.js-show-more-variants')
        const quickBuyOptions = this.querySelector('.js-quickbuy-variant-picker-options')
        if (!showMoreButton || !quickBuyOptions) return

        showMoreButton.addEventListener('click', () => {
          const isExpanded = quickBuyOptions.classList.toggle('active')
          showMoreButton.setAttribute('aria-expanded', String(isExpanded))
        })

        requestAnimationFrame(() => {
          const selectors = quickBuyOptions.querySelectorAll('input[type="radio"].swatch-radio, label')
          if (selectors.length > 1) {
            const firstTop = selectors[0].offsetTop
            let hasMultipleLines = false
            for (let i = 1; i < selectors.length; i++) {
              if (selectors[i].offsetTop > firstTop + 5) {
                hasMultipleLines = true
                break
              }
            }
            if (!hasMultipleLines) {
              showMoreButton.style.display = 'none'
            }
          }
        })
      }

      updateProductCardMedia() {
        if (!this.currentVariant.featured_image) return

        const productCard = this.closest('.js-product-card, .js-bundle-product-card, .js-upsell-product-card')
        const activeMedia = productCard.querySelector('img.active')

        const newMedia = productCard.querySelector(`[data-variant-id="${this.currentVariant.id}"]`)

        if (!newMedia) return

        activeMedia.classList.remove('active')
        newMedia.classList.add('active')
      }

      updateOptions() {
        const quickBuyOptions = Array.from(this.querySelectorAll('.js-quickbuy-variant-picker-options'))
        this.options = quickBuyOptions.map((quickBuyOption) => quickBuyOption.querySelector('input:checked')?.value)
      }

      updateVariantInfo() {
        const variantTitle = this.querySelector('.js-quickbuy-variant-title')
        const metafield = variantTitle.getAttribute('metafield')

        variantTitle.innerHTML = this.currentVariant.title
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(`#${this.dataset.productFormId}, #product-form-installment`)

        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]')

          input.value = this.currentVariant.id
          input.dispatchEvent(new Event('change', { bubbles: true }))
        })

        document.dispatchEvent(
          new CustomEvent('variantChanged', {
            detail: { variantId: this.currentVariant.id },
          })
        )

        this.updateVariantInfo()
      }
    }
  )
}
